import tag from './tag';

export const semantic = (value: any) => tag(value);

export default semantic;
